/** @jsx jsx */
import { jsx } from '@emotion/core';
import { N300 } from '@atlaskit/theme/colors';
import { gs } from '../utils';
export var Byline = function (_a) {
    var text = _a.text, children = _a.children, testId = _a.testId;
    return (jsx("span", { css: {
            marginTop: gs(1.5),
            fontSize: gs(1.5),
            lineHeight: gs(2.5),
            color: "" + N300,
            fontWeight: 'normal',
            // Spec: only allow two lines MAX to be shown.
            display: '-webkit-box',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            WebkitLineClamp: 2,
            WebkitBoxOrient: 'vertical',
            // Fallback options.
            maxHeight: gs(5),
        }, "data-testid": testId }, text || children));
};
//# sourceMappingURL=Byline.js.map